import * as React from "react";
import {AdminAnalyticsApi} from "../../../../api/AdminAnalyticsApi";
import {LoadingSpinner} from "../../../icons/LoadingSpinner.component";
import {DEFAULT_ENGAGEMENT} from "../shared/analytics.constants";
import {useAnalyticsTabData} from "../hooks/useAnalyticsTabData";
import {AreaUsageSection} from "./AreaUsageSection.component";
import {PowerUsersTable} from "./PowerUsersTable.component";
import {SessionDepthChart} from "./SessionDepthChart.component";
import {DocumentEngagementTable} from "./DocumentEngagementTable.component";

interface IEngagementTabProps {
    range: { startDate: string; endDate: string };
    country: string;
}

export const EngagementTab: React.FC<IEngagementTabProps> = (props) => {
    const {data, loading, error} = useAnalyticsTabData(
        "engagement",
        (startDate, endDate, c) => AdminAnalyticsApi.getEngagementTab(startDate, endDate, c),
        props.range,
        props.country,
        DEFAULT_ENGAGEMENT,
    );

    if (loading) {
        return <div className="admin-analytics__tab-loading"><LoadingSpinner/></div>;
    }
    if (error) {
        return <div className="admin-analytics__error">{error}</div>;
    }

    return (
        <div>
            <AreaUsageSection
                areaUsage={data.areaUsage}
                allAreaUsage={data.allAreaUsage}
                areaTrends={data.areaTrends}
            />
            <PowerUsersTable
                internalPowerUsers={data.internalPowerUsers}
                clientPowerUsers={data.clientPowerUsers}
                range={props.range}
                country={props.country}
            />
            {data.sessionDepth.length > 0 && (
                <SessionDepthChart sessionDepth={data.sessionDepth} avgSessionDepth={data.avgSessionDepth}/>
            )}
            {data.documentOpens.length > 0 && (
                <DocumentEngagementTable
                    documentOpens={data.documentOpens}
                    totalWhitePaperOpens={data.totalWhitePaperOpens}
                    totalMarketOutlookOpens={data.totalMarketOutlookOpens}
                    contentUniqueUsers={data.contentUniqueUsers}
                />
            )}
        </div>
    );
};
